module.exports = __webpack_public_path__ + "static/media/blog-new3.c796123a.jpg";